// CodeDisplay.js
import React, { useState, useEffect } from 'react';

const CodeDisplay = ({ content, onContentChange }) => {
  const [previewContent, setPreviewContent] = useState(content);

  const handleCodeChange = (event) => {
    const newContent = event.target.value;
    onContentChange(newContent);
  };

  useEffect(() => {
    setPreviewContent(content);
  }, [content]);

  return (
    <div className="flex flex-col md:flex-col md:w-full mt-4 md:mt-0">
      <div className="w-full pr-4">
        <div>
          <h3 className="text-xl font-bold mb-2">HTML Code:</h3>
          <textarea value={content} onChange={handleCodeChange} rows={10} cols={50} className="w-full p-2 border rounded" />
        </div>
      </div>
      <div className="w-full">
        <div>
          <h3 className="text-xl font-bold mb-2">Preview:</h3>
          <div dangerouslySetInnerHTML={{ __html: previewContent }} className="whitespace-pre-line" />
        </div>
      </div>
    </div>
  );
};

export default CodeDisplay;
